<template>
  <div id="backup">
    <el-backtop :visibility-height="300" :right="40" :bottom="40">
      <div
        style="{
        height: 100%;
        width: 100%;
        background-color: #f2f5f6;
        box-shadow: 0 0 6px rgba(0,0,0, .12);
        text-align: center;
        line-height: 40px;
        color: #1989fa;
        border-radius: 50%;
      }"
      >
        up
      </div>
    </el-backtop>
  </div>
</template>

<script>
export default {
  name: "TopTap"
}
</script>

<style scoped>
  #backup{
    overflow-y: scroll;
  }
</style>
